import { List } from 'immutable';

//TODO: client, device, supply as immmutable/Record
let clientId = 0;
function createClient(name, contact, devices) {
    return { id: `client_${clientId++}`, name, contact, devices };
}

let deviceId = 0;
function createDevice(manufacturer, model, supplies) {
    return { id: `device_${deviceId++}`, manufacturer, model, supplies };
}

let suppliesId = 0;
function createSupply(type, number) {
    return { id: `supply_${suppliesId++}`, type, number };
}

const data = List([
    createClient(
        'PaperCast',
        "81 749 54 54",
        List([
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            )
            , createDevice(
                "Hewlett-Packard",
                "MFP M032 1232",
                List([
                    createSupply("toner", "MLT-GADSA-A"),
                    createSupply("toner", "MLT-GADSA-B"),
                    createSupply("toner", "MLT-GADSA-C"),
                    createSupply("imagingUnit", "ING-IEQ")
                ])
            )
        ])
    ),
    createClient(
        'Piotronic-Service',
        "606 679 908",
        List([
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            ),
        ])
    ),
    createClient(
        'Profixer Serwis',
        "506 129 159",
        List([
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            ),
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            ),
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            )
        ])
    ),
    createClient(
        'Ecom Computer',
        "65 520 78 07",
        List([
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            )
        ])
    ),
    createClient(
        "FORMAT Handel I Usługi",
        "asdasd@asd.com",
        List([
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            ),
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            ),
            createDevice(
                "Hewlett-Packard",
                "MFP M630z B3G86",
                List([
                    createSupply("toner", "MLT-D116L-A"),
                    createSupply("toner", "MLT-D116L-B"),
                    createSupply("toner", "MLT-D116L-C")
                ])
            )
        ])
    ),
]);

export default data;


// WEBPACK FOOTER //
// ./src/modules/clients/src/data.js